<header class="topbar">
  <div class="topbar-left">
    <button (click)="toggleSidebar()" class="icon-btn mobile-menu-toggle" aria-label="Toggle menu">
      ☰
    </button>
  </div>
  <div class="topbar-right">
    <button (click)="toggleTheme()" class="icon-btn" aria-label="Toggle theme">
      <span class="material-symbols-outlined">
        {{ themeService.getCurrentTheme() === 'dark' ? 'light_mode' : 'dark_mode' }}
      </span>
    </button>
    <button (click)="logout()" class="icon-btn" aria-label="Logout">
      <span class="material-symbols-outlined">logout</span>
    </button>
  </div>
</header>